namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoItem9Form {
        PmGroupId: Serenity.StringEditor;
        PmId: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        PmExtCode: Serenity.StringEditor;
        PmStepNo: Serenity.IntegerEditor;
        PmDesc: Serenity.StringEditor;
        PmOrder: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        NpcsOrBundlePrice: Serenity.DecimalEditor;
        AssortFg: Serenity.EnumEditor;
        EndBillPmType: Serenity.RadioButtonEditor;
        CouponTypeLookup: LookupCoupons;
        CouponType: Serenity.StringEditor;
        FreeLpFg: Serenity.RadioButtonEditor;
        DiscPc: Serenity.DecimalEditor;
        DiscAmt: Serenity.DecimalEditor;
        CouponAgeDay: Serenity.IntegerEditor;
        CouponGiftDesc: Serenity.TextAreaEditor;
        ListFg: Serenity.RadioButtonEditor;
        PluCode: Serenity.LookupEditor;
        StyleCode: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        SupplCode: Serenity.LookupEditor;
    }

    export class PsAdvPromoItem9Form extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoItem9';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoItem9Form.init)  {
                PsAdvPromoItem9Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.EnumEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = LookupCoupons;
                var w6 = s.TextAreaEditor;
                var w7 = s.LookupEditor;

                Q.initFormType(PsAdvPromoItem9Form, [
                    'PmGroupId', w0,
                    'PmId', w0,
                    'PmType', w1,
                    'PmExtCode', w0,
                    'PmStepNo', w1,
                    'PmDesc', w0,
                    'PmOrder', w1,
                    'LineItemNo', w1,
                    'NpcsOrBundlePrice', w2,
                    'AssortFg', w3,
                    'EndBillPmType', w4,
                    'CouponTypeLookup', w5,
                    'CouponType', w0,
                    'FreeLpFg', w4,
                    'DiscPc', w2,
                    'DiscAmt', w2,
                    'CouponAgeDay', w1,
                    'CouponGiftDesc', w6,
                    'ListFg', w4,
                    'PluCode', w7,
                    'StyleCode', w7,
                    'BrandCode', w7,
                    'CatCode', w7,
                    'SubCat1Code', w7,
                    'SubCat2Code', w7,
                    'SupplCode', w7
                ]);
            }
        }
    }
}
